import { render } from "./AccountSettings.vue?vue&type=template&id=137ee63d&scoped=true&ts=true"
import script from "./AccountSettings.vue?vue&type=script&lang=ts"
export * from "./AccountSettings.vue?vue&type=script&lang=ts"

import "./AccountSettings.vue?vue&type=style&index=0&id=137ee63d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137ee63d"]])

export default __exports__